import { getAuthHeaderProvider } from "@src/appV2/Auth/cognito/authHeaderProviderRef";

export const getAuthHeader = async () => {
  const authHeaderValue = await getAuthHeaderProvider()?.();

  return { Authorization: authHeaderValue };
};
